import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom';
import { LOGO } from '../../components/image';
import '../login/login.css'
import { createClient } from '@supabase/supabase-js'
import { toast } from 'react-toastify';
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_API_KEY
const supabase = createClient(supabaseUrl, supabaseKey)


const Register = () => {
    const navigate = useNavigate();

    const handleRegister = async (event) => {
        event.preventDefault()
        const formData = new FormData(event.target);
        var object = {};
        formData.forEach(function (value, key) {
            object[key] = value;
        });
        console.log(object);

        const { data: {session}, error } = await supabase.auth.signUp({
            phone: '+13334445555',
            password: 'some-password',
        })
        
        if(error) {
            toast(error);
        }

        if (session) {
            console.log(session);
            navigate('/')
        }

    };

    return (
        <>
            <div className="text-start ms-5 mt-5">
                <img src={LOGO} height={40} width={40} />
            </div>
            <div className="d-flex justify-content-center align-items-center" style={{ height: '90vh' }}>
                <form onSubmit={handleRegister}>
                    <div className="login-box">
                        <div className="text-start">Register</div>


                        <div className="d-flex align-items-center input-box">
                            <input name='name' type="text" placeholder="User name" />
                            <ion-icon name="person-outline"></ion-icon>
                        </div>
                        <div className="d-flex align-items-center input-box">
                            <input name='email' type="text" placeholder="Email" />
                            <ion-icon name="mail-outline"></ion-icon>
                        </div>

                        <div className="d-flex align-items-center  input-box">
                            <input name='password' type="password" placeholder="Password" />
                            <ion-icon name="eye-outline"></ion-icon>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                            <input type="checkbox" />
                            <label>Remember Me.</label>
                        </div>

                        <NavLink to={"/login"}>
                            <label className='text-decoration-none text-black'>You have already an account ?? <label className="forgot-password mt-3 fw-bold">Login now</label></label>
                        </NavLink>

                        <button type='submit' className="btn-form mt-5">
                            Register
                        </button>


                    </div>
                </form>
            </div>
        </>
    );
}

export default Register